export default function CollapseOne() {
    return (
        <div className="flex flex-col my-2 gap-4">
            <p>Hipersensibilidad al levetiracetam, o a otros derivados de la porrolidona o a cualquiera de los
                componentes de la fórmula. medicamento.
                No debe de utilizarse en el embarazo y la lactancia.</p>
        </div>
    )
        ;
}